"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translatedStrings = exports.getImmediateNodesTypes = void 0;

var _externalization = require("../../../../externalization");

var getImmediateNodesTypes = {
  GET_IMMEDIATE_NODES_REQUEST: 'GET_IMMEDIATE_NODES_REQUEST',
  GET_IMMEDIATE_NODES_LOADING: 'GET_IMMEDIATE_NODES_LOADING',
  GET_IMMEDIATE_NODES_SUCCESS: 'GET_IMMEDIATE_NODES_SUCCESS',
  GET_IMMEDIATE_NODES_FAILURE: 'GET_IMMEDIATE_NODES_FAILURE'
};
exports.getImmediateNodesTypes = getImmediateNodesTypes;
var translatedStrings = {
  noActionsAvailableText: (0, _externalization.translate)('SECRETS_MODULE.NO_ACTIONS_AVAILABLE')
};
exports.translatedStrings = translatedStrings;